/**
 * Команды ведущего: dashboard -> сервер -> мир игры.
 *
 * ЗАЧЕМ ОТДЕЛЬНОЕ НАПРАВЛЕНИЕ. Все три поколения протокола везут состояние ОТ
 * игры К зрителю, а событие зрителя идёт к игре через привязки. Обратной
 * стороны - команды САМОГО ВЕДУЩЕГО - не было вовсе, и без неё стример в эфире
 * не может ни поставить паузу, ни перезапустить раунд, ни обратиться к
 * аудитории через кадр. Это три вещи, нужные постоянно, а не косметика ради
 * сходства с эталоном.
 *
 * КОМАНДА ИДЁТ ЧЕРЕЗ СЕРВЕР, А НЕ ПРЯМО В OVERLAY. Мир авторитетен на сервере:
 * там крутится тик, там живёт состояние, оттуда уходят дельты. Пауза,
 * применённая только в кадре, означала бы, что кадр стоит, а мир продолжает
 * идти, - и при первом же ресинке зритель увидит скачок на минуту вперёд.
 *
 * СООБЩЕНИЕ ЗРИТЕЛЯМ - НЕ КОМАНДА ИГРЕ, и поэтому канал у него свой. Игра о
 * нём ничего не знает и знать не должна: текст ведущего рисует overlay поверх
 * сцены и снимает по истечении длительности. Слить его в команды значило бы
 * заставить каждую из десяти игр уметь показывать чужой текст.
 */
/**
 * Что умеет ведущий. Список закрытый: каждая команда - это ещё и кнопка в
 * dashboard, и обработка в игре, а «произвольная команда строкой» превращает
 * контракт в догадку.
 */
export const DIRECTOR_COMMANDS = ['pause', 'resume', 'restartRound'];
export function isDirectorCommand(value) {
    return typeof value === 'string' && DIRECTOR_COMMANDS.includes(value);
}
/** Границы длительности показа. Одно место для сервера, экрана и оверлея. */
export const DIRECTOR_MESSAGE_SECONDS = { min: 3, max: 60, default: 10 };
/** Предел длины сообщения: строка в кадре, а не пост. */
export const DIRECTOR_MESSAGE_MAX_LENGTH = 200;
//# sourceMappingURL=director-command.js.map